export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmWUlfCRc4AMP6lbBP.37d54986.woff2";